export const config = {
  network: 'mainnet',
  plausible: "UTI7PAASILRDA3ISHY5M7J7LNRX2AIVQJWI7ZKCCGKVLMFD3VPR5PWSZ4I",
  mainnet: {
    mainAddr: '23QHOYLQJUYXXWKHBZJRQGL45BS6HZNXZ4XBLFYFJDC5B45Z642UL5E2GY',
    mainId: '946441472',
    algod: 'https://mainnet-api.algonode.cloud/v2',
    indexer: 'https://mainnet-idx.algonode.cloud/v2',
    node: 'https://mainnet-api.algonode.cloud',
    applink: 'https://allo.info',
    asalink: 'https://explorer.perawallet.app',
    ipfs: 'https://goplausible.mypinata.cloud',
    api: 'https://goplausible.xyz/api',
    ai: 'https://ai.goplausible.xyz/agent',
    host: 'https://goplausible.xyz',
    githubClientId: 'c8e56bac468a9380c9c2',
    githubAppId: 2486324,
  }
} as const;

// Helper function to get current network config
export const getCurrentNetwork = () => {
  return config[config.network as 'mainnet'];
};

// Helper function to get API URL
export const getApiUrl = (): string => {
  return getCurrentNetwork().api;
};

// Helper function to get API URL
export const getAiApiUrl = (): string => {
  return getCurrentNetwork().ai;
};

// Helper function to get Algod endpoint
export const getAlgodEndpoint = (): string => {
  return getCurrentNetwork().algod;
};

// Helper function to get Node endpoint
export const getNodeEndpoint = (): string => {
  return getCurrentNetwork().node;
};

// Helper function to get Indexer endpoint
export const getIndexerEndpoint = (): string => {
  return getCurrentNetwork().indexer;
};

// Helper function to get IPFS endpoint
export const getIpfsEndpoint = (): string => {
  return getCurrentNetwork().ipfs;
};

// Helper function to get Plausible address
export const getPlausibleAddress = (): string => {
  return config.plausible;
};

// Helper function to get main address
export const getMainAddress = (): string => {
  return getCurrentNetwork().mainAddr;
};

// Helper function to get main ID
export const getMainId = (): string => {
  return getCurrentNetwork().mainId;
};
